import React from "react";
import { orderBy } from "lodash";

// You can type these more strongly for better safety!
export const formatValue = (
    value: unknown,
    formatter?: (value: unknown, item: unknown, idx: number, items: unknown[]) => string,
    item?: unknown,
    idx?: number,
    items?: unknown[]
): string => {
    if (formatter) {
        return formatter(value, item, idx, items);
    } else {
        return (value || "").toString();
    }
};

// Custom type guard for function type
function isClassNameFn(
    className: string | ((item: unknown, idx: number, items: unknown[]) => string)
): className is (item: unknown, idx: number, items: unknown[]) => string {
    return typeof className === "function";
}

export const processClassName = (
    className: string | ((item: unknown, idx: number, items: unknown[]) => string),
    item?: unknown,
    idx?: number,
    items?: unknown[]
): string => {
    if (isClassNameFn(className)) {
        return className(item, idx, items);
    } else {
        return className || "";
    }
};

export const sortData = (data: any[], sortCol?: string | ((item: any) => any), sortOrder?: "asc" | "desc") => {
    if (!sortCol) return data;

    return orderBy(data, [sortCol], [sortOrder]);
};

export const isNullOrUndefined = (value: unknown): boolean => {
    return value === null || typeof value === "undefined";
};
